export default __webpack_public_path__ + "static/media/christmas-bell-left.8d7f6b6c.png";